<template>
  <div>
    <b-tabs :multiline="true" :animated="false">
      <b-tab-item>
        <template #header>
          <b-tooltip
            :label="$t('compCarbonDocsHelpManual.introduction.title')"
            type="is-black"
          >
            <b-icon icon="info" />
          </b-tooltip>
        </template>
        <b-notification :has-icon="true" icon="info" :closable="false">
          <span v-html="$t('compCarbonDocsHelpManual.introduction.text-1')" />
          <br />
          <span v-html="$t('compCarbonDocsHelpManual.introduction.text-2')" />
          <br /><br />
          <span v-html="$t('compCarbonDocsHelpManual.introduction.text-3')" />
          <br /><br />
          <span v-html="$t('compCarbonDocsHelpManual.introduction.text-4')" />
        </b-notification>
      </b-tab-item>
      <b-tab-item>
        <template #header>
          <b-tooltip
            :label="$t('compCarbonDocsHelpManual.boundaries.title')"
            type="is-black"
          >
            <b-icon icon="square" />
          </b-tooltip>
        </template>
        <b-notification :has-icon="true" icon="database" :closable="false">
          <span v-html="$t('compCarbonDocsHelpManual.boundaries.text')" />
        </b-notification>
      </b-tab-item>
      <b-tab-item
        v-for="(module, index) in modules"
        :key="index"
        :icon="getIcon(module)"
      >
        <template #header>
          <b-tooltip :label="$t(module)" type="is-black">
            <b-icon :icon="getIcon(module)" />
          </b-tooltip>
        </template>
        <component :is="importName(module)" />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import { useCoreStore } from '@/stores/core.js'
import Modules from '@/models/Modules.js'

export default {
  name: 'HelpManual',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  },
  props: ['header'],
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    modules: function () {
      // we only want the top level module types of active modules
      return this.coreStore.activeModules(false)
    }
  },
  methods: {
    getIcon: function (module) {
      return Modules.getIcon(module)
    },
    importName: function (module) {
      return module + 'Help'
    }
  },
  beforeMount () {
    for (let module of this.modules) {
      Vue.component(
        this.importName(module),
        // A dynamic import returns a Promise.
        () => import('@/components/carbon/forms/' + module + '/HelpManual.vue')
      )
    }
  }
}
</script>
